/**
 * Datetime helpers for Solid modules. Workflow timestamps are epoch MICROSECONDS
 * (mosy `datetimeus` fields); `<input type="datetime-local">` speaks local ISO strings.
 */

/** Epoch µs → localized date-time string ('' for empty). */
export function fmtDt(us) {
  if(!us) return ''
  return new Date(Math.floor(us / 1000)).toLocaleString('sk')
}

/** Epoch µs → compact `DD.MM.YYYY HH:mm` for tables ('—' when empty; bosy meleTable format). */
export function fmtDtShort(us) {
  if(!us) return '—'
  const dt = new Date(Math.floor(Number(us) / 1000))
  if(isNaN(dt.getTime())) return String(us)
  const pad = n=>String(n).padStart(2, '0')
  return `${pad(dt.getDate())}.${pad(dt.getMonth() + 1)}.${dt.getFullYear()} ${pad(dt.getHours())}:${pad(dt.getMinutes())}`
}

/** Epoch µs → `datetime-local` input value (seconds precision). */
export function usToLocalInput(us) {
  if(!us) return ''
  const dt = new Date(Math.floor(us / 1000))
  const pad = n=>String(n).padStart(2, '0')
  return `${dt.getFullYear()}-${pad(dt.getMonth() + 1)}-${pad(dt.getDate())}T${pad(dt.getHours())}:${pad(dt.getMinutes())}:${pad(dt.getSeconds())}`
}

/** `datetime-local` input value → epoch µs ('' when unparsable). */
export function localInputToUs(value) {
  const ms = new Date(value).getTime()
  return isNaN(ms) ? '' : ms * 1000
}
